import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-dark to-darker border-t-2 border-primary/30 py-16 px-4">
      <div className="container mx-auto">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            {/* Brand & Description */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center shadow-lg shadow-primary/30">
                  <span className="text-white font-bold text-xl">B</span>
                </div>
                <span className="text-2xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent font-heading">
                  Breaking the Matrix
                </span>
              </div>
              <p className="text-gray-400 mb-6 max-w-xl text-lg leading-relaxed">
                A psychology presentation exploring how centuries of mental conditioning shaped South Asian mindset — 
                and how our generation can break free through awareness and independent thinking.
              </p>
              <div className="bg-gradient-to-r from-primary/10 to-accent/10 border-l-4 border-primary pl-6 py-4 rounded-r-lg max-w-xl">
                <p className="text-gray-300 italic text-lg">
                  "Until our minds are free, no amount of progress will ever be real."
                </p>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl font-bold text-white mb-6 font-heading">Sections</h3>
              <ul className="space-y-3">
                <li><a href="#home" className="text-gray-400 hover:text-primary transition-colors duration-300 text-lg">Introduction</a></li>
                <li><a href="#the-matrix" className="text-gray-400 hover:text-accent transition-colors duration-300 text-lg">The Matrix</a></li>
                <li><a href="#creativity-problem" className="text-gray-400 hover:text-secondary transition-colors duration-300 text-lg">Creativity Problem</a></li>
                <li><a href="#break-free" className="text-gray-400 hover:text-warning transition-colors duration-300 text-lg">Breaking Free</a></li>
                <li><a href="#message" className="text-gray-400 hover:text-primary transition-colors duration-300 text-lg">Message</a></li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t-2 border-primary/20 my-8"></div>

          {/* Presentation Credits */}
          <div className="bg-gradient-to-br from-primary/10 via-accent/5 to-secondary/10 border-2 border-primary/30 rounded-2xl p-8 md:p-10 mb-8">
            <div className="flex items-center justify-center gap-6 mb-6">
              {/* COMSATS Logo */}
              <img 
                src="/uni-logo.webp" 
                alt="COMSATS University" 
                className="h-16 w-16 object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <div className="h-12 w-px bg-primary/30"></div>
              <div className="text-center">
                <h3 className="text-2xl font-bold text-white font-heading">
                  Psychology Presentation
                </h3>
                <p className="text-primary font-semibold">COMSATS University Islamabad, Lahore Campus</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
              <div className="text-center md:text-left">
                <p className="text-gray-500 text-sm uppercase tracking-wider mb-2">Student</p>
                <p className="text-2xl font-bold text-primary">Shafin Uz Zaman</p>
                <p className="text-gray-400">BS Computer Science</p>
              </div>
              <div className="text-center md:text-right">
                <p className="text-gray-500 text-sm uppercase tracking-wider mb-2">Instructor</p>
                <p className="text-2xl font-bold text-accent">Amna Nisar</p>
                <p className="text-gray-400">Psychology Department</p>
              </div>
            </div>
          </div>

          {/* Bottom Footer */}
          <div className="text-center space-y-4">
            {/* Social Links */}
            <div className="flex justify-center space-x-6 mb-6">
              <a href="https://github.com/shafin2" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-primary transition-colors duration-300 transform hover:scale-110" aria-label="GitHub">
                <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
              <a href="https://linkedin.com/in/shafin-zaman" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-primary transition-colors duration-300 transform hover:scale-110" aria-label="LinkedIn">
                <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>

            <div className="h-px w-48 bg-gradient-to-r from-transparent via-primary to-transparent mx-auto mb-4"></div>

            <p className="text-gray-400 text-lg">
              © 2025 Breaking the South Asian Matrix
            </p>
            <p className="text-gray-500 text-sm">
              A psychology presentation on mental conditioning and freedom of thought
            </p>
            <p className="text-gray-600 text-sm mt-4">
              Made with 💙 for those seeking mental freedom
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;